import {
  LANGUAGE_CODE_FRENCH,
  LANGUAGE_CODE_KOREAN,
  LANGUAGE_CODE_SPANISH,
} from './language'

export const ENVIRONMENT: string = process?.env?.NEXT_PUBLIC_ENVIRONMENT
  ? process?.env?.NEXT_PUBLIC_ENVIRONMENT?.toString().trim().toLowerCase()
  : 'dev'
export const IS_PRODUCTION: boolean = ENVIRONMENT == 'prod'
export const IS_QA: boolean = ENVIRONMENT == 'dev'
export const IS_LOCAL: boolean = ENVIRONMENT == 'local'
export const HOST: string = process?.env?.NEXT_PUBLIC_HOST
  ? process?.env?.NEXT_PUBLIC_HOST.toString().trim()
  : ''
export const DEBUG_MODE: boolean = false

export const STREAMY3_OFFICIAL_BUSINESS_NAME: string = 'Streamy3, LLC'
export const STREAMY3_INFORMAL_BUSINESS_NAME: string = 'Practical Stream'
export const STREAMY3_OFFICIAL_ADDRESS_LINE_1: string =
  '5830 E 2nd St., Ste 7000'
export const STREAMY3_OFFICIAL_ADDRESS_LINE_2: string = '#14870'
export const STREAMY3_OFFICIAL_ADDRESS_CITY: string = 'Casper'
export const STREAMY3_OFFICIAL_ADDRESS_STATE_CODE: string = 'WY'
export const STREAMY3_OFFICIAL_ADDRESS_ZIP_CODE: string = '82609'
export const STREAMY3_OFFICIAL_ADDRESS_COUNTRY: string = 'United States'

export const APP_DOMAIN: string = process?.env?.NEXT_PUBLIC_APP_DOMAIN
  ? process?.env?.NEXT_PUBLIC_APP_DOMAIN?.toString().trim()
  : ''

export const USE_CDN: boolean = !IS_LOCAL
export const USE_ARWEAVED_APP_ICONS: boolean = false

export const USE_GOOGLE_ANALYTICS: boolean = true
export const GOOGLE_ANALYTICS_TAG: string = 'AW-17143498120'
export const GOOGLE_ANALYTICS_SCRIPT: string = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${GOOGLE_ANALYTICS_TAG}');`

export const HOME_PAGE_DISPLAY_NAME: string = 'HomePage'
export const FOUR_O_FOUR_PAGE_DISPLAY_NAME: string = 'FourOFourPage'
export const FIVE_HUNDRED_PAGE_DISPLAY_NAME: string = 'FiveHundredPage'
export const ERROR_PAGE_DISPLAY_NAME: string = 'ErrorPage'
export const HOW_THE_RIGHT_PLAYLIST_PAGE_DISPLAY_NAME: string =
  'HowTheRightPlaylistPage'
export const SECRET_SOUNDTRACK_FORMULA_PAGE_DISPLAY_NAME: string =
  'SecretSoundtrackFormulaPage'
export const SPOTIFY_ISNT_LEGAL_PAGE_DISPLAY_NAME: string =
  'SpotifyIsntLegalPage'
export const HOW_MUCH_PAGE_DISPLAY_NAME: string = 'HowMuchIsAMusicLicensePage'
export const HOW_MUSIC_BOOSTS_PAGE_DISPLAY_NAME: string = 'HowMusicBoostsPage'
export const HOW_TO_BUILD_PAGE_DISPLAY_NAME: string = 'HowToBuildPage'
export const FIVE_MISTAKES_PAGE_DISPLAY_NAME: string = 'FiveMistakesPage'
export const SUBSCRIPTION_BASED_VS_TRADITIONAL_PAGE_DISPLAY_NAME: string =
  'SubscriptionBasedVsTraditionalPage'
export const SPOTIFY_IN_COFEE_SHOPS_PAGE_DISPLAY_NAME: string =
  'SpotifyInCoffeeShops'

export const SELECTED_LANGUAGE_COOKIE_NAME: string = process?.env
  ?.NEXT_PUBLIC_SELECTED_LANGUAGE_COOKIE_NAME
  ? process?.env?.NEXT_PUBLIC_SELECTED_LANGUAGE_COOKIE_NAME?.toString().trim()
  : ''
export const CONTACT_EMAIL: string = process?.env?.NEXT_PUBLIC_CONTACT_EMAIL
  ? process?.env?.NEXT_PUBLIC_CONTACT_EMAIL
  : ''
export const MAIN_SITE_PRODUCTION_HOST: string = process?.env
  ?.NEXT_PUBLIC_MAIN_SITE_PRODUCTION_HOST
  ? process?.env?.NEXT_PUBLIC_MAIN_SITE_PRODUCTION_HOST
  : ''
export const MAIN_SITE_ENVIRONMENT_HOST: string = process?.env
  ?.NEXT_PUBLIC_MAIN_SITE_ENVIRONMENT_HOST
  ? process?.env?.NEXT_PUBLIC_MAIN_SITE_ENVIRONMENT_HOST
  : ''
export const PRODUCTION_HOST: string = process?.env?.NEXT_PUBLIC_PRODUCTION_HOST
  ? process?.env?.NEXT_PUBLIC_PRODUCTION_HOST.toString().trim()
  : ''
export const MAIN_SITE_ENVIRONMENT_HOST_ES =
  MAIN_SITE_ENVIRONMENT_HOST + '/' + LANGUAGE_CODE_SPANISH
export const MAIN_SITE_ENVIRONMENT_HOST_FR =
  MAIN_SITE_ENVIRONMENT_HOST + '/' + LANGUAGE_CODE_FRENCH
export const MAIN_SITE_ENVIRONMENT_HOST_KO =
  MAIN_SITE_ENVIRONMENT_HOST + '/' + LANGUAGE_CODE_KOREAN
export const PRACTICAL_STREAM_CDN_ADDRESS: string = process?.env
  ?.NEXT_PUBLIC_PRACTICAL_STREAM_CDN_ADDRESS
  ? process?.env?.NEXT_PUBLIC_PRACTICAL_STREAM_CDN_ADDRESS
  : ''
export const ARWEAVE_NODE: string = process?.env?.NEXT_PUBLIC_ARWEAVE_NODE
  ? process?.env?.NEXT_PUBLIC_ARWEAVE_NODE?.toString().trim()
  : ''
export const ARWEAVE_GATEWAY_MAIN: string = process?.env
  ?.NEXT_PUBLIC_ARWEAVE_NODE
  ? process?.env?.NEXT_PUBLIC_ARWEAVE_NODE?.toString().trim()
  : ''
export const USE_ENV_PROTECTION_MODAL: boolean =
  process?.env?.NEXT_PUBLIC_USE_ENV_PROTECTION_MODAL &&
  process?.env?.NEXT_PUBLIC_USE_ENV_PROTECTION_MODAL?.toString()
    .trim()
    .toLowerCase() == 'true'
    ? true
    : false
export const ENV_PROTECTION_COOKIE_NAME: string = process?.env
  ?.NEXT_PUBLIC_ENV_PROTECTION_COOKIE_NAME
  ? process?.env?.NEXT_PUBLIC_ENV_PROTECTION_COOKIE_NAME?.toString().trim()
  : ''
export const READY_TO_TRANSFORM_COMPONENT_ID: string =
  '72D9DB9F-4487-419F-B232-4432DB4B1BD2'
export function formatDateForJsonLdField(date: Date | null): string {
  let ret: string = '2025-11-28T03:24:00Z'
  try {
    if (date != null) {
      const year = date.getFullYear()
      const month: string = (date.getMonth() + 1).toString().padStart(2, '0')
      const day: string = date.getDate().toString().padStart(2, '0')
      const hours: string = date.getHours().toString().padStart(2, '0')
      const minutes: string = date.getMinutes().toString().padStart(2, '0')
      const seconds: string = date.getSeconds().toString().padStart(2, '0')
      ret = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}` + 'Z'
    }
  } catch {}
  return ret
}
function formatLocalISOForCookieExpires(date: Date | null): string {
  let ret: string = '2029-12-28T03:24:00'
  try {
    if (date != null) {
      const year = date.getFullYear()
      const month: string = (date.getMonth() + 1).toString().padStart(2, '0')
      const day: string = date.getDate().toString().padStart(2, '0')
      const hours: string = date.getHours().toString().padStart(2, '0')
      const minutes: string = date.getMinutes().toString().padStart(2, '0')
      const seconds: string = date.getSeconds().toString().padStart(2, '0')
      ret = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
    }
  } catch {}
  return ret
}
const cookieExpiration: string = formatLocalISOForCookieExpires(
  new Date(new Date().setFullYear(new Date().getFullYear() + 4)),
)
export const COOKIE_CONFIG = {
  path: '/',
  domain:
    HOST == 'http://localhost:3000' || HOST == 'https://localhost:3000'
      ? 'localhost'
      : APP_DOMAIN,
  expires: new Date(cookieExpiration),
  sameSite: true,
}

export const HOME_PS_LOGO: string =
  ARWEAVE_GATEWAY_MAIN + 'AkCjLipY8aabtWJNjpQ8OQd0VBlMVMJgzltJoj8QFBE'

export const JSON_LD_AUTHOR_AND_PUBLISHER_IMAGE_FOR_GOOGLE_TOP_STORIES: string =
  USE_CDN
    ? PRACTICAL_STREAM_CDN_ADDRESS + 'E8DD4030-F673-4440-9D15-B9139CAAF92E.png'
    : HOST + '/images/E8DD4030-F673-4440-9D15-B9139CAAF92E.png'
export const JSON_LD_AUTHOR_AND_PUBLISHER_IMAGE_FOR_GOOGLE_TOP_STORIES_PIXELS_HEIGHT: string =
  '60'
export const JSON_LD_AUTHOR_AND_PUBLISHER_IMAGE_FOR_GOOGLE_TOP_STORIES_PIXELS_WIDTH: string =
  '600'

export const TITLE_TAG_HOME: string = 'Blog - Practical Stream'
export const TITLE_TAG_HOME_SPANISH: string = 'Blog - Practical Stream'
export const TITLE_TAG_HOME_FRENCH: string = 'Bloguer - Practical Stream'
export const TITLE_TAG_HOME_KOREAN: string = '블로그 - Practical Stream'

export const BLOG_DESCRIPTION_HOME: string =
  'This blog serves as an authoritative resource that bridges the gap between commercial strategy and psychoacoustic research, offering expert analysis on how background music influences consumer behavior and brand identity.'
export const BLOG_DESCRIPTION_HOME_ES: string =
  'Este blog es una fuente de referencia que tiende un puente entre la estrategia empresarial y la investigación psicoacústica, ofreciendo análisis de expertos sobre cómo la música de fondo influye en el comportamiento del consumidor y la identidad de marca.'
export const BLOG_DESCRIPTION_HOME_FR: string =
  "Ce blog constitue une ressource de référence qui fait le lien entre la stratégie commerciale et la recherche psychoacoustique, en proposant des analyses d'experts sur la manière dont la musique d'ambiance influence le comportement des consommateurs et l'identité des marques."
export const BLOG_DESCRIPTION_HOME_KO: string =
  '이 블로그는 상업 전략과 심리음향학 연구 사이의 간극을 메우는 권위 있는 자료로서, 배경 음악이 소비자 행동과 브랜드 정체성에 미치는 영향에 대한 전문가 분석을 제공합니다.'

export const TITLE_TAG_ERROR_FOUR_O_FOUR_FIVE_HUNDRED: string =
  'Error - Practical Stream'
export const TITLE_TAG_ERROR_FOUR_O_FOUR_FIVE_HUNDRED_SPANISH: string =
  'Error - Practical Stream'
export const TITLE_TAG_ERROR_FOUR_O_FOUR_FIVE_HUNDRED_FRENCH: string =
  'Erreur - Practical Stream'
export const TITLE_TAG_ERROR_FOUR_O_FOUR_FIVE_HUNDRED_KOREAN: string =
  '오류 - Practical Stream'

export const META_DESCRIPTION_HOME: string =
  'We provide expert guidance and recommendations on creating the perfect background music for your restaurant, store, gym, spa, or other commercial venue.'
export const META_DESCRIPTION_HOME_SPANISH: string =
  'Ofrecemos asesoramiento y recomendaciones expertas para crear la música de fondo ideal para su restaurante, tienda, gimnasio, spa u otro establecimiento comercial.'
export const META_DESCRIPTION_HOME_FRENCH: string =
  "Nous vous proposons des conseils d'experts et des recommandations pour créer la musique d'ambiance idéale pour votre restaurant, magasin, salle de sport, spa ou autre établissement commercial."
export const META_DESCRIPTION_HOME_KOREAN: string =
  '레스토랑, 매장, 체육관, 스파 또는 기타 상업 장소에서 완벽한 배경 음악을 만드는 데 대한 전문가의 지침과 권장 사항을 제공합니다.'
export const META_KEYWORDS_HOME: string =
  'blog, background music, bgm, music stream, background music streaming, business background music, ambient music, licensed music, music for restaurants, music for retail, practical stream'
export const META_KEYWORDS_HOME_SPANISH: string =
  'blog, música ambiental, música de fondo, transmisión de música, música ambiental para negocios, música ambiental, música con licencia, música para restaurantes, música para comercios, practical stream'
export const META_KEYWORDS_HOME_FRENCH: string =
  "blogue, musique d'ambiance, musique de fond, streaming musical, musique d'ambiance pour entreprises, musique d'ambiance, musique sous licence, musique pour restaurants, musique pour magasins, practical stream"
export const META_KEYWORDS_HOME_KOREAN: string =
  '블로그, 배경음악, BGM, 음악 스트리밍, 배경음악 스트리밍, 비즈니스 배경음악, 앰비언트 음악, 라이선스 음악'

export const JSON_LD_SITE_NAME: string = 'Practical Stream - Blog'
export const JSON_LD_SITE_NAME_SPANISH: string = 'Practical Stream - Blog'
export const JSON_LD_SITE_NAME_FRENCH: string = 'Practical Stream - Bloguer'
export const JSON_LD_SITE_NAME_KOREAN: string = 'Practical Stream - 블로그'
export const JSON_LD_TYPE_HOME: string = 'website'
export const JSON_LD_TYPE_FOUR_O_FOUR: string = 'website'
export const JSON_LD_TYPE_FIVE_HUNDRED: string = 'website'
export const JSON_LD_TYPE_ERROR: string = 'website'
export const JSON_LD_TYPE_ARTICLE: string = 'article'
export const JSON_LD_ORGANIZATION_DESCRIPTION_DEFAULT: string =
  'Music streaming service for restaurants, bars, nightclubs, gyms, retail stores and other commercial spaces.'
export const JSON_LD_ORGANIZATION_DESCRIPTION_DEFAULT_SPANISH: string =
  'Servicio de transmisión de música para restaurantes, bares, discotecas, gimnasios, tiendas minoristas y otros espacios comerciales.'
export const JSON_LD_ORGANIZATION_DESCRIPTION_DEFAULT_FRENCH: string =
  'Service de streaming musical pour restaurants, bars, discothèques, salles de sport, magasins de détail et autres espaces commerciaux.'
export const JSON_LD_ORGANIZATION_DESCRIPTION_DEFAULT_KOREAN: string =
  '레스토랑, 바, 나이트클럽, 체육관, 소매점 및 기타 상업 공간을 위한 음악 스트리밍 서비스입니다.'
export const JSON_LD_URL_HOME_ENGLISH = HOST
export const JSON_LD_URL_HOME_FRENCH = HOST + '/' + LANGUAGE_CODE_FRENCH + ''
export const JSON_LD_URL_HOME_SPANISH = HOST + '/' + LANGUAGE_CODE_SPANISH + ''
export const JSON_LD_URL_HOME_KOREAN = HOST + '/' + LANGUAGE_CODE_KOREAN + ''
export const JSON_LD_DESCRIPTION_GENERIC: string =
  'Blog for the Practical Stream music streaming service provided to restaurants, bars, nightclubs, gyms, retail stores and other commercial spaces.'
export const JSON_LD_DESCRIPTION_GENERIC_SPANISH: string =
  'Blog para el servicio de transmisión de música Practical Stream brindado a restaurantes, bares, discotecas, gimnasios, tiendas minoristas y otros espacios comerciales.'
export const JSON_LD_DESCRIPTION_GENERIC_FRENCH: string =
  'Blog pour le service de streaming musical Practical Stream fourni aux restaurants, bars, discothèques, salles de sport, magasins de détail et autres espaces commerciaux.'
export const JSON_LD_DESCRIPTION_GENERIC_KOREAN: string =
  '레스토랑, 바, 나이트클럽, 체육관, 소매점 및 기타 상업 공간에 제공되는 Practical Stream 음악 스트리밍 서비스에 대한 블로그입니다.'
export const JSON_LD_TITLE_GENERIC: string = 'Blog - Practical Stream'
export const JSON_LD_TITLE_GENERIC_SPANISH: string = 'Blog - Practical Stream'
export const JSON_LD_TITLE_GENERIC_FRENCH: string = 'Bloguer - Practical Stream'
export const JSON_LD_TITLE_GENERIC_KOREAN: string = '블로그 - Practical Stream'
export const OPEN_GRAPH_PAGE_IMAGE: string =
  ARWEAVE_GATEWAY_MAIN + 'nTgumqx84phoj_85g2Zpm5i1kJsLVTl9M0x75uOTm2M'
export const OPEN_GRAPH_PAGE_IMAGE_SPANISH: string =
  ARWEAVE_GATEWAY_MAIN + 's5qMRrd0gCmmy2UTNeXfpl7uAKKHSp6so5yBznN2vlI'
export const OPEN_GRAPH_PAGE_IMAGE_FRENCH: string =
  ARWEAVE_GATEWAY_MAIN + 'ZxwGHV7TsHOH36xtCsVW8AAGOO4fy39ZcSlQQ4bIrKY'
export const OPEN_GRAPH_PAGE_IMAGE_KOREAN: string =
  ARWEAVE_GATEWAY_MAIN + '3bTfIEgbXs5Nrgb_BLb3sdYOBc85IePNdKUthb7nURM'

export const CANONICAL_URL_HOME_ENGLISH = HOST
export const CANONICAL_URL_HOME_FRENCH = HOST + '/' + LANGUAGE_CODE_FRENCH + ''
export const CANONICAL_URL_HOME_SPANISH =
  HOST + '/' + LANGUAGE_CODE_SPANISH + ''
export const CANONICAL_URL_HOME_KOREAN = HOST + '/' + LANGUAGE_CODE_KOREAN + ''

export const OG_HOME_URL: string = HOST
export const OG_IMAGE_WIDTH: string = '1280'
export const OG_IMAGE_HEIGHT: string = '720'
export const OG_SITE_NAME: string = 'Practical Stream - Blog'
export const OG_SITE_NAME_SPANISH: string = 'Practical Stream - Blog'
export const OG_SITE_NAME_FRENCH: string = 'Practical Stream - Bloguer'
export const OG_SITE_NAME_KOREAN: string = 'Practical Stream - 블로그'
export const OG_SITE_URL: string = CANONICAL_URL_HOME_ENGLISH
export const OG_SITE_URL_FRENCH: string = HOST + '/' + LANGUAGE_CODE_FRENCH + ''
export const OG_SITE_URL_SPANISH: string =
  HOST + '/' + LANGUAGE_CODE_SPANISH + ''
export const OG_SITE_URL_KOREAN: string = HOST + '/' + LANGUAGE_CODE_KOREAN + ''

export const OG_PAGE_URL_HOME: string = CANONICAL_URL_HOME_ENGLISH
export const OG_PAGE_URL_HOME_SPANISH: string = OG_SITE_URL_SPANISH
export const OG_PAGE_URL_HOME_FRENCH: string = OG_SITE_URL_FRENCH
export const OG_PAGE_URL_HOME_KOREAN: string = OG_SITE_URL_KOREAN

export const OG_PAGE_URL_ERROR: string = CANONICAL_URL_HOME_ENGLISH + '/error'
export const OG_PAGE_URL_ERROR_SPANISH: string = OG_SITE_URL_SPANISH + '/error'
export const OG_PAGE_URL_ERROR_FRENCH: string = OG_SITE_URL_FRENCH + '/error'
export const OG_PAGE_URL_ERROR_KOREAN: string = OG_SITE_URL_KOREAN + '/error'

export const OG_PAGE_URL_FIVE_HUNDRED: string =
  CANONICAL_URL_HOME_ENGLISH + '/500'
export const OG_PAGE_URL_FIVE_HUNDRED_SPANISH: string =
  OG_SITE_URL_SPANISH + '/500'
export const OG_PAGE_URL_FIVE_HUNDRED_FRENCH: string =
  OG_SITE_URL_FRENCH + '/500'
export const OG_PAGE_URL_FIVE_HUNDRED_KOREAN: string =
  OG_SITE_URL_KOREAN + '/500'

export const OG_PAGE_URL_FOUR_O_FOUR: string =
  CANONICAL_URL_HOME_ENGLISH + '/404'
export const OG_PAGE_URL_FOUR_O_FOUR_SPANISH: string =
  OG_SITE_URL_SPANISH + '/404'
export const OG_PAGE_URL_FOUR_O_FOUR_FRENCH: string =
  OG_SITE_URL_FRENCH + '/404'
export const OG_PAGE_URL_FOUR_O_FOUR_KOREAN: string =
  OG_SITE_URL_KOREAN + '/404'

export const PRACTICAL_STREAM_LOGO_LARGE_DARK_PNG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'C185DA47-94DA-4853-9C08-CE7E49117902.png'
  : '/images/C185DA47-94DA-4853-9C08-CE7E49117902.png'
export const PRACTICAL_STREAM_LOGO_LARGE_DARK_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'C185DA47-94DA-4853-9C08-CE7E49117902.avif'
  : '/images/C185DA47-94DA-4853-9C08-CE7E49117902.avif'

export const LOGO_AVIF = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '67C9A4DD-62D2-49CF-B8C4-F1E157257F79.avif'
  : '/images/67C9A4DD-62D2-49CF-B8C4-F1E157257F79.avif'
export const LOGO_PNG = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '67C9A4DD-62D2-49CF-B8C4-F1E157257F79.png'
  : '/images/67C9A4DD-62D2-49CF-B8C4-F1E157257F79.png'

export const SMOKY_SPEAKER_AVIF = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'F233E23E-7D92-4AE3-B43D-3718F21DC324.avif'
  : '/images/F233E23E-7D92-4AE3-B43D-3718F21DC324.avif'
export const SMOKY_SPEAKER_JPG = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'F233E23E-7D92-4AE3-B43D-3718F21DC324.jpg'
  : '/images/F233E23E-7D92-4AE3-B43D-3718F21DC324.jpg'

export const SMOKY_SPEAKER_AVIF_NO_PADDING = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '6DC217FA-2507-49F2-97E0-B6EC36359B72.avif?a=1'
  : '/images/6DC217FA-2507-49F2-97E0-B6EC36359B72.avif'
export const SMOKY_SPEAKER_JPG_NO_PADDING = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '6DC217FA-2507-49F2-97E0-B6EC36359B72.jpg'
  : '/images/6DC217FA-2507-49F2-97E0-B6EC36359B72.jpg'

export const DRINK_AVIF = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '4A76D115-8983-44C1-AAF3-65F271E1CC77.avif'
  : '/images/4A76D115-8983-44C1-AAF3-65F271E1CC77.avif'
export const DRINK_JPG = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '4A76D115-8983-44C1-AAF3-65F271E1CC77.jpeg'
  : '/images/4A76D115-8983-44C1-AAF3-65F271E1CC77.jpeg'

export const ANDROID_CHROME_ICON_192_X_192: string =
  '/android-chrome-192x192.png'
export const ANDROID_CHROME_ICON_256_X_256: string =
  '/android-chrome-256x256.png'
export const ANDROID_CHROME_ICON_384_X_384: string =
  '/android-chrome-384x384.png'
export const ANDROID_CHROME_ICON_512_X_512: string =
  '/android-chrome-512x512.png'
export const ANDROID_CHROME_ICON_144_X_144: string =
  '/android-chrome-144x144.png'
export const ANDROID_CHROME_ICON_128_X_128: string =
  '/android-chrome-128x128.png'
export const ANDROID_CHROME_ICON_72_X_72: string = '/android-chrome-72x72.png'
export const ANDROID_CHROME_ICON_48_X_48: string = '/android-chrome-48x48.png'
export const ANDROID_CHROME_ICON_36_X_36: string = '/android-chrome-36x36.png'
export const ANDROID_CHROME_512_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + 'kuW6bJ9ayVwc87uPjDw0_3-RjQKKyAJI3IU5-xVGHlY'
  : ANDROID_CHROME_ICON_512_X_512
export const ANDROID_CHROME_384_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + 'gTghgwAoo773Lf89wOmGCs-E_6ss5YI_8S9Wf1uW3nA'
  : ANDROID_CHROME_ICON_384_X_384
export const ANDROID_CHROME_256_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + 'Lo3KvBawKxgfGEbetuV_4_I_IBlD5pcDsLGQ6pcc9s0'
  : ANDROID_CHROME_ICON_256_X_256
export const ANDROID_CHROME_192_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + '6wQQvZ0z1rf_RNrJQgIqXIC2Lejx-VL8sektmkcoXAQ'
  : ANDROID_CHROME_ICON_192_X_192
export const ANDROID_CHROME_144_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + 'E4cNPCHVMUcKQ6Q7PdusQWXy5XaBQLVhl7V46NE78QQ'
  : ANDROID_CHROME_ICON_144_X_144
export const ANDROID_CHROME_128_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + '2uUHh0ZtjspeYvkT2TllrlaeyBwGQLWO0VtzDYbPIWo'
  : ANDROID_CHROME_ICON_128_X_128
export const ANDROID_CHROME_72_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + 'JhHlKNigM1xqmkYfJ18SCUWssF5_Ho0gWiImpM7gtic'
  : ANDROID_CHROME_ICON_72_X_72
export const ANDROID_CHROME_48_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + '7o7lR42JxYSHxeqI2y8ot3UgZBohwu_2JZ1dOJRlj-c'
  : ANDROID_CHROME_ICON_48_X_48
export const ANDROID_CHROME_36_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + 'aUwGY5HnkRgcMNh_33FSlNpeAFW4P5P8WSTE9D313wY'
  : ANDROID_CHROME_ICON_36_X_36
export const APPLE_TOUCH_180_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + 'SWi4-1ODaCMfWHdQ4mVxD4qO8ZhsXtEkzKmiDOq4t2k'
  : '/apple-touch-icon-180x180.png'
export const APPLE_TOUCH_152_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + 'jKtB3rpPD50mWwxDXTJ2KOS8TpZ0ul1KV91U394rcVg'
  : '/apple-touch-icon-152x152.png'
export const APPLE_TOUCH_144_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + 'dBALrteUPgOK6F1rwo8_QLckZw-8DKBb0ltJPXf12QU'
  : '/apple-touch-icon-144x144.png'
export const APPLE_TOUCH_120_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + 'QO8jDNb14WES66LYzvLwM_qC5evkXvSOU84TF5FdTew'
  : '/apple-touch-icon-120x120.png'
export const APPLE_TOUCH_114_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + 'vqRVTMw7F-x_2mHjn-7ZBDaO3_afs-bF5iWx9pPmhzY'
  : '/apple-touch-icon-114x114.png'
export const APPLE_TOUCH_76_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + 'KewQXYkmI0FyQk-lEdyVXMkkSesayJtF3PvWDLGu94I'
  : '/apple-touch-icon-76x76.png'
export const APPLE_TOUCH_72_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + 'qLjr7lq0EKby33DWUHabfpaK3A11iazH00-LsxF7xAU'
  : '/apple-touch-icon-72x72.png'
export const APPLE_TOUCH_60_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + 'LCXxdj6Sg0Os5uRPLZpTgsuoNSHoiS5qZ7AbztKQTtI'
  : '/apple-touch-icon-60x60.png'
export const APPLE_TOUCH_57_ICON: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + 'ncbkX-mpT1cnTyH8iHYpeKnMMZUL8BMHAGi249m1i8o'
  : 'apple-touch-icon-57x57.png'
export const APPLE_TOUCH_STARTUP_IMAGE_1: string =
  ARWEAVE_GATEWAY_MAIN + 'j651LaY2Dm_JC6VkuJi5pgzOHjc7V0dEDjidAedqpcQ'
export const APPLE_TOUCH_STARTUP_IMAGE_2: string =
  ARWEAVE_GATEWAY_MAIN + 'sXD-MiP5iGvz1GHnExAQzLupHNQLc6q92VmlyrzsxRw'
export const APPLE_TOUCH_STARTUP_IMAGE_3: string =
  ARWEAVE_GATEWAY_MAIN + 'sXD-MiP5iGvz1GHnExAQzLupHNQLc6q92VmlyrzsxRw'
export const APPLE_TOUCH_STARTUP_IMAGE_4: string =
  ARWEAVE_GATEWAY_MAIN + 'QmrCkpbSq9XWSPuTxyC8pn8FuUrSDg4UO78j53QXxN0'
export const APPLE_TOUCH_STARTUP_IMAGE_5: string =
  ARWEAVE_GATEWAY_MAIN + 'Ji3mvJfMeWZr9m2qG8T4V6i7dVlRZherT1I2_SjDNS4'
export const APPLE_TOUCH_STARTUP_IMAGE_6: string =
  ARWEAVE_GATEWAY_MAIN + '13PDCgrYGME-bGeiSDkZtf9ziMRVRIJBi-1EhmoyzMk'
export const APPLE_TOUCH_STARTUP_IMAGE_7: string =
  ARWEAVE_GATEWAY_MAIN + 'BQaC8q0VSkZTsA6qp1OUJ_WDNRuT0zok8AJk94pXTlc'
export const APPLE_TOUCH_STARTUP_IMAGE_8: string =
  ARWEAVE_GATEWAY_MAIN + 'luv6jvDV1Wb2zXHW5QXfVraToPJJC0EWmvOXdFoRJs4'
export const APPLE_TOUCH_STARTUP_IMAGE_9: string =
  ARWEAVE_GATEWAY_MAIN + 't6caBOleawYasYYoh0TonzgzrswNWJZRsQSe4u88tO0'
export const APPLE_TOUCH_STARTUP_IMAGE_10: string =
  ARWEAVE_GATEWAY_MAIN + 'eX0RmdrRmV9cMw1dTPR9nztYmkWAPodGUPEZsvS38Xc'
export const APPLE_TOUCH_STARTUP_IMAGE_11: string =
  ARWEAVE_GATEWAY_MAIN + 'Vrsh2jeWSrdrTk7JFpVkWirY9fsLHoIJbxekEg26riQ'
export const APPLE_TOUCH_STARTUP_IMAGE_12: string =
  ARWEAVE_GATEWAY_MAIN + 'xO-TB6i1UFxIEjSuLxfpimftAHjQdaeAwmiiA_TFvk0'
export const APPLE_TOUCH_STARTUP_IMAGE_13: string =
  ARWEAVE_GATEWAY_MAIN + 'APN9gpZjcOLT6cxM8bHq3BB8ioNl4bN5x_mGXe09tFU'
export const APPLE_TOUCH_STARTUP_IMAGE_14: string =
  ARWEAVE_GATEWAY_MAIN + '0V87WuZ_tNG8q8cPP6BlUWx8M_wHncxsDf9enL-dcW4'
export const APPLE_TOUCH_STARTUP_IMAGE_15: string =
  ARWEAVE_GATEWAY_MAIN + 'dHd1hEZvMq7yT7vwPTEw4jj99-_3f0mqZBrQwxwAB3Q'
export const APPLE_TOUCH_STARTUP_IMAGE_16: string =
  ARWEAVE_GATEWAY_MAIN + 'yw_xtehUpJCQfuTyLHfuosbwhFetvnMBBiJv_-YGz98'
export const APPLE_TOUCH_STARTUP_IMAGE_17: string =
  ARWEAVE_GATEWAY_MAIN + 'e9L6ZqotHQ6rhWgcPWFyJcMTegQnthPU7WBj0KOCXM0'
export const APPLE_TOUCH_STARTUP_IMAGE_18: string =
  ARWEAVE_GATEWAY_MAIN + 'MWiLSRiB-8oA5aC53ZgSck_BOSDLGWdFldDFmA8Mio4'
export const APPLE_TOUCH_STARTUP_IMAGE_19: string =
  ARWEAVE_GATEWAY_MAIN + 'np5gN-IUM0bgt4nmEFScldX_Bju85nDqwtaG-8ql4TQ'
export const APPLE_TOUCH_STARTUP_IMAGE_20: string =
  ARWEAVE_GATEWAY_MAIN + 'yoH38QWq4Xd9q_nmnRhmeHixn50ITRUVmBTyZyH0jyk'
export const APPLE_TOUCH_STARTUP_IMAGE_21: string =
  ARWEAVE_GATEWAY_MAIN + 'D1q3ICoyrU0IWvldXSHBGSdxcD3uX14cAxrNnjRNLcI'
export const APPLE_TOUCH_STARTUP_IMAGE_22: string =
  ARWEAVE_GATEWAY_MAIN + 'zaRvdHcfMLIY08fAzwxKZJcAFlwA6tCjzWVLrOImodE'
export const APPLE_TOUCH_STARTUP_IMAGE_23: string =
  ARWEAVE_GATEWAY_MAIN + 'sF15h8TPkcJ8Uqk6LrYBXUsM3IxgIesw1Ta_-nqghQ4'
export const APPLE_TOUCH_STARTUP_IMAGE_24: string =
  ARWEAVE_GATEWAY_MAIN + 'FbwwsYrd9YU_uRd3ENJtBY38vEYH9bKBbV45yW_31VA'
export const APPLE_TOUCH_STARTUP_IMAGE_25: string =
  ARWEAVE_GATEWAY_MAIN + 'Hf6vnRk9PyE5q8GZ3ibvxyC6VfVRSuU-AhbC707M3Oo'
export const APPLE_TOUCH_STARTUP_IMAGE_26: string =
  ARWEAVE_GATEWAY_MAIN + 'gRTCwZeIh7Ul2qObFfK4u5ZUwZc9w6MvR_RfsZtn56k'
export const APPLE_TOUCH_STARTUP_IMAGE_27: string =
  ARWEAVE_GATEWAY_MAIN + 'qQZRPXQvYuUS-cy6qeLo7Egbvft70oBXptZgpEn1ahU'
export const APPLE_TOUCH_STARTUP_IMAGE_28: string =
  ARWEAVE_GATEWAY_MAIN + 'Z-T63nkPx6gWu5kaMNKumzgWUC7YMxsOUN2QZBGtr80'
export const APPLE_TOUCH_STARTUP_IMAGE_29: string =
  ARWEAVE_GATEWAY_MAIN + 'Rk211R3hnxl9Oax0er9Cbst1SASdxRJBNHz7At9YxXI'
export const APPLE_TOUCH_STARTUP_IMAGE_30: string =
  ARWEAVE_GATEWAY_MAIN + 'dW-UZhg8sfJPTSPBe-9Rz1MLwuzmmELajh1CK59g4QM'
export const APPLE_TOUCH_STARTUP_IMAGE_31: string =
  ARWEAVE_GATEWAY_MAIN + 'dW-UZhg8sfJPTSPBe-9Rz1MLwuzmmELajh1CK59g4QM'
export const APPLE_TOUCH_STARTUP_IMAGE_32: string =
  ARWEAVE_GATEWAY_MAIN + 'EwruYMKVYoCKwjvXTSo4USO3bnU4gT32MvDuXTG-1TE'
export const APPLE_TOUCH_STARTUP_IMAGE_33: string =
  ARWEAVE_GATEWAY_MAIN + 'HDNHmJO-f2BrxKH5tDzmo-Jgs08-istGnTGFUnrKxXI'
export const APPLE_TOUCH_STARTUP_IMAGE_34: string =
  ARWEAVE_GATEWAY_MAIN + 'w97CS-NBPY6_4HuW4S857f4M39_-vM4IhjVnnj_05d8'
export const SAFARI_PINNED_TAB_CDN_OR_LOCAL: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'safari-pinned-tab.svg'
  : '/safari-pinned-tab.svg'
export const MS_TILE_144_CDN_OR_LOCAL: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'mstile-144x144.png'
  : '/mstile-144x144.png'
export const FAV_ICON_CDN_OR_LOCAL: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'favicon.ico'
  : '/favicon.ico'
export const FAV_ICON_194: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + 'O4s55VvxOvdxxBXqgJ5nNK2pmziyQnfnK19Rn1BBQHs'
  : '/favicon-194x194.png'
export const FAV_ICON_96: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + 'Ot3SwC71CVcEiUGFrwPR1bLqZrIUfH3YCH0_ksm61Cs'
  : '/favicon-96x96.png'
export const FAV_ICON_32: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + 'M-vJo0PnH8MxUz5MiRAIWro1j7BhFcud_IMTyF9axCA'
  : '/favicon-32x32.png'
export const FAV_ICON_16: string = USE_ARWEAVED_APP_ICONS
  ? ARWEAVE_GATEWAY_MAIN + '8m1Qu9gYNe8RXPH1q6fgzYmQzR0XT7CfVgb9Si_dWa8'
  : '/favicon-16x16.png'
export const SVG_ICON_CDN_OR_LOCAL: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'icon.svg'
  : '/icon.svg'
